<script setup>
  import AppDrawer from '@/components/AppDrawer.vue';
  import AppHeader from '@/components/AppHeader.vue';
  import { useLayoutStore } from '@/stores/layout.store.js';
  import { useDisplay } from 'vuetify';
  const props = defineProps({
    showDrawer: {
      type: Boolean,
      default: true,
    },
    drawerRail: {
      type: Boolean,
      default: false,
    },
    drawerRailWidth: {
      type: Number,
      default: 56,
    },
  });

  const { mobile } = useDisplay();

  const settingsNavigationSideBar = computed({
    get() {
      return useLayoutStore().settingsNavigationSideBar;
    },
    set(value) {
      useLayoutStore().settingsNavigationSideBar = value;
    },
  });

  watchEffect(() => {
    useLayoutStore().settingsNavigationSideBar = !mobile.value && settingsNavigationSideBar.value;
  });
</script>

<template>
  <v-app id="partnrup" class="tw-block tw-h-[100vh]">
    <AppDrawer v-if="showDrawer" :rail="drawerRail" :rail-width="drawerRailWidth" v-model="settingsNavigationSideBar">
      <slot name="drawer" />
    </AppDrawer>
    <slot name="header">
      <AppHeader></AppHeader>
    </slot>
    <v-main>
      <div class="tw-h-[97vh] tw-w-full tw-overflow-auto tw-bg-[#f9fafb] tw-px-4 tw-pl-4">
        <slot name="main" />
      </div>
    </v-main>
  </v-app>
</template>

<style scoped>
  #partnrup :deep(.v-application__wrap) {
    @apply tw-block tw-h-[100vh];
  }
</style>
